import React from 'react';
import { Layout } from 'app/components/base/Layout';
import LoadingSpinner from 'app/components/base/LoadingSpinner';


/**
 * Screen (overlay absolutelly positioned) with loading indicator.
 * You can provide size for loading icon with "iconSize" prop.
 * Acceptable values is: "normal"(default), "large", "small"
 */
const LoadingScreen = ({
  children,
  iconSize,
  align = 'center center',
  className,
}) => (
  <Layout
    direction="column"
    align={align}
    className={className}
    nowrap
  >
    {children}
    <LoadingSpinner size={iconSize} />
  </Layout>
);

// TODO: move to Flow types
// LoadingScreen.propTypes = {
//   iconSize: PropTypes.string,
//   children: PropTypes.node
// };

export default LoadingScreen;
